import * as React from 'react';
import { useDeepCompareEffect, useTimeoutFn } from 'react-use';
export const createContext = defaultValue => {
  const Context = React.createContext(defaultValue);
  const useContext = () => {
    const ctx = React.useContext(Context);
    if (!ctx) throw new Error('useContext must be inside a Provider!');
    return ctx;
  };
  return [useContext, Context];
};
export const useDeepCompareDebounce = (fn, debounceMs = 0, deps = []) => {
  const [isReady, cancel, reset] = useTimeoutFn(fn, debounceMs);
  useDeepCompareEffect(reset, deps);
  return [isReady, cancel];
};
export const useThrowError = () => {
  const [, setError] = React.useState();
  const throwError = React.useCallback(error => {
    setError(() => {
      throw error;
    });
  }, []);
  return throwError;
};
export const nest = (...components) => {
  return components.reduceRight((InnerComponent, OuterComponent) => {
    return props => React.createElement(OuterComponent, props, React.createElement(InnerComponent, props));
  });
};